import useMixpanelEventsForRoutes from 'hooks/useMixpanelEventsForRoutes'

const MixpanelEventsForRoutes = () => {
  useMixpanelEventsForRoutes()

  return null
}

export default MixpanelEventsForRoutes
